<script setup lang="ts">
import type { MonsterType } from '@/types/monster'
import { explainMonsterAffix } from '@/core/monster/affix'
import { useUserStore } from '@/stores/modules/user'
import { socketEmitAsync } from '@/utils/web-socket'

const props = defineProps<{ monsterList: MonsterType[]; type: 'normal' | 'advance' | 'peak' }>()
const userStore = useUserStore()

async function handleSetAutoChangeRoutine() {
  await socketEmitAsync({
    type: 'setAutoChangeRoutine',
    data: { onlyOffline: userStore.advanceAutoChangeRoutineSet.onlyOffline, onlyNoDungeon: userStore.advanceAutoChangeRoutineSet.onlyNoDungeon },
  })
  ElMessage.success('设置成功')
}
async function handleSetAutoChangeRoutineList(monsterId: number, routineId: number) {
  await socketEmitAsync({ type: 'setAutoChangeRoutineList', data: { monsterId, routineId, type: props.type } })
  ElMessage.success('设置成功')
}
</script>

<template>
  <div class="auto-change-routine">
    <h2>设置自动换装</h2>
    <p>
      仅在无副本战斗时生效
      <el-switch v-model="userStore.advanceAutoChangeRoutineSet.onlyNoDungeon" size="small" @change="handleSetAutoChangeRoutine" />
    </p>
    <p>仅离线生效 <el-switch v-model="userStore.advanceAutoChangeRoutineSet.onlyOffline" size="small" @change="handleSetAutoChangeRoutine" /></p>
    <div class="set-routine-list">
      <div class="item" v-for="item of monsterList">
        <el-popover placement="bottom" :width="300" trigger="click" popper-class="monster-detail" :teleported="false">
          <template #reference>
            <el-button size="small" type="danger" plain style="width: 100px">
              {{ item?.name }}
            </el-button>
          </template>
          <div class="monster-detail">
            <NewMonsterDetail :monster="item" />
          </div>
        </el-popover>
        <span>：</span>
        <el-select
          size="small"
          v-model="
            userStore[
              props.type === 'normal'
                ? 'autoChangeRoutineList'
                : props.type === 'advance'
                ? 'advanceAutoChangeRoutineList'
                : 'peakAutoChangeRoutineList'
            ][item.id]
          "
          style="margin-top: 10px"
          @change="(val) => handleSetAutoChangeRoutineList(item.id, val)"
          popper-class="max-z-index"
          clearable
          :value-on-clear="0"
        >
          <el-option :value="0" label="未设置"></el-option>
          <el-option v-for="item in userStore.equippedRoutineList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.set-routine-list {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .el-select {
    margin-top: 0 !important;
  }
}
.monster-detail {
  p {
    margin: 2px 0;
  }
}
</style>
